import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import Advertisement from './advertisement';
import Payable from './payable';
import axios from 'axios';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  filePath: '',
  remarks: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});
const CreateUnitMaster = () => {
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setloader] = useState(false);
  // Master Listings
  const [measurementList, setMeasurementList] = useState([]);
  const [salersList, setSalesPersonList] = useState([]);
  const [bedRoomList, setBedRoomList] = useState([]);
  const [landlordList, setLandlordList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [communityList, setcommunityList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [imageView, setImageView] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [cityList, setCityList] = useState([]);
  // Unit Listings
  const [manDateList, setManDateList] = useState([]);
  const [reserveAccList, setReserveAccList] = useState([]);
  const [keyStatusList, setKeyStatusList] = useState([]);
  const [unitCostList, setUnitCostList] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [costAccount, setCostAccount] = useState([]);
  const [agent, setAgent] = useState([]);
  const [furnishing, setFurnishing] = useState([]);
  const [refferedBy, setRefferedBy] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [furniturePlan, setFurniturePlan] = useState([]);
  const [period, setPeriod] = useState([]);
  const [sizeType, setSizeType] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [currencyList, setCurrency] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const validationRules = [
    { key: 'property', message: 'Please Select Property' },
    { key: 'unitNo', message: 'Please Enter Unit No' },
    { key: 'unitClass', message: 'Please Enter Unit Class' },
    { key: 'unitType', message: 'Please Enter Unit Type' },
    { key: 'unitCategory', message: 'Please Enter Unit Category' },
    { key: 'unitView', message: 'Please Enter Unit View' },
    { key: 'bedRooms', message: 'Please Enter Bed Room' },
    { key: 'totalArea', message: 'Please Enter Total Area' },
  ];
  const [transectionData, setTransectionData] = useState({
    saller: null,
    landlordId: null,
    property: null,
    community: null,
    unitType: null,
    unitCategory: null,
    country: null,
    city: null,
    unitView: null,
    floor: null,
    bedRooms: null,
    unitNo: '',
    contactPerson: '',
    municipltyNo: '',
    refNo: '',
    unitClass: 'Sale',
    sector: '',
    block: '',
    bathRoom: '',
    balcony: '',
    livingarea: '',
    terraceArea: '',
    totalArea: '',
    parking: '',
    unitRate: '',
    remarks: '',
    parkingPrice: '',
    resale: false,
  });
  const [unitDetails, setUnitDetails] = useState({
    mandate: null,
    reservedAccCode: null,
    statusKey: null,
    unitCost: null,
    paymentPlan: null,
    status: null,
    costAccount: null,
    agent: null,
    furnishing: null,
    refferedBy: null,
    enteredBy: null,
    furniturePlan: null,
    unitModel: '',
    serviceCharge: '',
    unitStyle: '',
    reservedFund: '',
    storeRoom: '',
    plotNO: '',
    company: '',
    financeOffered: '',
    rentAmount: '',
    plotSize: '',
    additionalWorkCost: '',
    streetNo: '',
    opt2Cost: '',
    opt3Cost: '',
    furnitureCost: '',
    occupied: false,
    propertyRegistered: false,
    mortgaged: false,
    leased: false,
    completionDate: formattedDate,
    expiryDate: formattedDate,
    reffferedDate: formattedDate,
    enteredDate: formattedDate,
    modifiedDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });
  const [advertisement, setAdvertisement] = useState({
    publishStatus: false,
    xmlFeed: false,
    openHouse: false,
    marketingDesc: '',
    remarks1: '',
    remarks2: '',
    remarks3: '',
  });

  useEffect(() => {
    fetchDropdownData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'UMReferredBy,UMProperties,UMEnteredBy,UMCostAccounts,UMBedrooms,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMImageTypes,UMAreaMeasurements,UMSalesPersons,UMKeyStatus,UMMandate,UMSizeTypes,UMPeriods',
      );
      const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
      const scndparams = new URLSearchParams();
      scndparams.append(
        'dropdownTypes',
        'UMSellerNames,UMReservedFundAccounts,UMAccounts,UMBanks,UMPaymentPlans,UMCountries,UMFurnished,UMCommunities,UMSellers,UMFurniturePlans,UMAgents,UMProjectStatus,UMFurnishing,UMCurrencies',
      );
      const scndRes = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${scndparams.toString()}`);
      setBedRoomList(res?.data?.dropdowns?.UMBedrooms);
      setCostAccount(res?.data?.dropdowns?.UMCostAccounts);
      setEnteredBy(res?.data?.dropdowns?.UMEnteredBy);
      setFloorList(res?.data?.dropdowns?.UMFloors);
      setImageView(res?.data?.dropdowns?.UMImageTypes);
      setKeyStatusList(res?.data?.dropdowns?.UMKeyStatus);
      setManDateList(res?.data?.dropdowns?.UMMandate);
      setPeriod(res?.data?.dropdowns?.UMPeriods);
      setPropertyList(res?.data?.dropdowns?.UMProperties);
      setRefferedBy(res?.data?.dropdowns?.UMReferredBy);
      setSizeType(res?.data?.dropdowns?.UMSizeTypes);
      setunitCategoryList(res?.data?.dropdowns?.UMUnitCategories);
      setunitViewList(res?.data?.dropdowns?.UMUnitViews);
      setUnitTypeList(res?.data?.dropdowns?.UMUnitTypes);
      setAgent(scndRes?.data?.dropdowns?.UMAgents);
      setProjectStatus(scndRes?.data?.dropdowns?.UMProjectStatus);
      setcommunityList(scndRes?.data?.dropdowns?.UMCommunities);
      setMeasurementList(scndRes?.data?.dropdowns?.UMAreaMeasurements);
      setUnitCostList(scndRes?.data?.dropdowns?.UMEnteredBy);
      setLandlordList(scndRes?.data?.dropdowns?.UMSellers);
      setSalesPersonList(scndRes?.data?.dropdowns?.UMSellers);
      setBankList(scndRes?.data?.dropdowns?.UMBanks);
      setPaymentPlan(scndRes?.data?.dropdowns?.UMPaymentPlans);
      setCountries(scndRes?.data?.dropdowns?.UMCountries);
      setFurnishing(scndRes?.data?.dropdowns?.UMFurnishing);
      setCurrency(scndRes?.data?.dropdowns?.UMCurrencies);
      setFurniturePlan(scndRes?.data?.dropdowns?.UMFurniturePlans);
      setReserveAccList(scndRes?.data?.dropdowns?.UMReservedFundAccounts);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  // Mirrors the legacy rbSale/rbLease/rbPropertyManagement_CheckedChanged tab-set logic.
  // Yearly Rent is always omitted for now — its visibility depends on a system setting
  // (checkMultiYrLease / tbLease_Setting) with no API exposed to the frontend yet.
  const getTabList = () => {
    const list = [
      { key: 'unitMaster', label: 'Unit Master' },
      { key: 'unitDetails', label: 'Unit Details' },
      { key: 'unitFeatures', label: 'Unit Features' },
    ];
    const unitClass = transectionData?.unitClass || 'Sale';
    if (unitClass === 'Lease') {
      list.push({ key: 'leaseDetails', label: 'Lease Details' });
      if (String(transectionData?.unitType?.label || '').toUpperCase() === 'COMMERCIAL') {
        list.push({ key: 'payable', label: 'Payable' });
      }
    } else if (unitClass === 'PM') {
      list.push({ key: 'leaseDetails', label: 'PM Details' });
      list.push({ key: 'payable', label: 'Payable' });
    } else {
      list.push({ key: 'salesDetails', label: 'Sales Details' });
      list.push({ key: 'buyerSummary', label: 'Buyer Summary' });
    }
    list.push({ key: 'advertisement', label: 'Advertisement' });
    list.push({ key: 'images', label: 'Images' });
    return list;
  };
  const tabList = getTabList();
  // The tab set changes shape with Unit Class, so a stale index could point at a
  // different tab (or nothing) after switching — reset to the first tab instead.
  useEffect(() => {
    setActiveTab(0);
  }, [transectionData?.unitClass]);
  const handleBackClick = () => {
    window.history.back();
  };
  // "Amount due to Developer" is always the complement of "Seller has Paid to Developer".
  const amountDueDev = (parseFloat(salesDetails?.orignalPrice) || 0) - (parseFloat(salesDetails?.sellerPaidDev) || 0);
  const amountDueDevPercent = 100 - (parseFloat(salesDetails?.sellerPaidDevCalcu) || 0);
  const handleSave = async () => {
    try {
      setloader(true);
      for (const rule of validationRules) {
        if (!transectionData?.[rule.key]) {
          setloader(false);
          toast.warning(rule.message);
          return;
        }
      }
      if (!salesDetails?.listingPrice) {
        setloader(false);
        toast.warning('Please Enter Listing Price');
        return;
      } else if (!unitDetails?.enteredBy?.label) {
        setloader(false);
        toast.warning('Please Select Entered By User');
        return;
      }

      const scndparams = new URLSearchParams();
      scndparams.append('Action', 'CheckDuplicateUnit');
      scndparams.append('PropertyNo', transectionData?.property?.value?.value);
      scndparams.append('UnitNo', transectionData?.unitNo);
      const scndRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${scndparams.toString()}`);
      const duplicateCheck = scndRes?.data?.result?.data?.[''];

      if (duplicateCheck === 1) {
        toast.warning('Unit already exists for this property');
        setloader(false);
        return;
      }
      const unitFeatures = featuresList?.map((item, index) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value: item?.Value,
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      let uploadedFiles = []
      const hasNewFiles = attachments?.some((item) => item.file instanceof File && item.isNew);
      if (hasNewFiles) {
        uploadedFiles = await handleUpload();
      }
      const unitImages = attachments?.reduce((acc, item) => {
        const uploadedFile = uploadedFiles.find(
          (file) => file.originalFileName === item.file?.name
        );

        if (uploadedFile?.fileName) {
          acc.push({
            record_Id: 0,
            image_Description: "0",
            image_Filename: uploadedFile.fileName,
            isDefault: true,
            folder: "0",
            url: uploadedFile.fullUrl || "0",
            isAdded: false,
            isUpdated: false,
            isDeleted: false,
          });
        }

        return acc;
      }, []);
      const body = {
        unitMasterMain: {
          unitMaster: {
            ref_No: transectionData?.refNo || '0',
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: transectionData?.municipltyNo || '0',
            street_No: unitDetails?.streetNo || '0',
            street_Name: leaseDetails?.IbanNo || '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: unitDetails?.unitStyle || '0',
            unit_Model: unitDetails?.unitModel || '0',
            unit_Zone: transectionData?.sector || '0',
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: transectionData?.block || '0',
            floor: transectionData?.floor?.label || '0',
            unit_View: transectionData?.unitView?.label || '0',
            completion_Date: unitDetails?.completionDate,
            unit_Class: transectionData?.unitClass || '0',
            livingRooms: transectionData?.livingarea || '0',
            bedrooms: transectionData?.bedRooms?.label || '0',
            storeRooms: unitDetails?.storeRoom || '0',
            parking: transectionData?.parking || '0',
            facilities: unitDetails?.furnishing?.label || '0',
            status: 'Available',
            payment_Plan: unitDetails?.paymentPlan?.label || '0',
            broker_Name: unitDetails?.agent?.label || '0',
            seller_Id: transectionData?.landlordId?.label || '0',
            seller_Name: transectionData?.saller?.label || '0',
            adv_Listing: Boolean(advertisement?.xmlFeed),
            adv_NewsPaper: false,
            adv_Web: false,
            adv_OpenHouse: Boolean(advertisement?.openHouse),
            adv1: false,
            adv2: false,
            adv3: false,
            adv_Remarks1: advertisement?.remarks1 || '0',
            adv_Remarks2: advertisement?.remarks2 || '0',
            adv_Remarks3: advertisement?.remarks3 || '0',
            remarks: advertisement?.marketingDesc || '0',
            internalRemarks: transectionData?.remarks || '0',
            otherSpace1: '0',
            bathrooms: transectionData?.bathRoom || '0',
            balcony: transectionData?.balcony || '0',
            terrace: transectionData?.terraceArea || '0',
            total_Area: parseFloat(transectionData?.totalArea) || 0,
            measured_Area: parseFloat(transectionData?.netArea) || 0,
            sqft_Rate: parseFloat(transectionData?.unitRate || 0),
            purchase_Value: parseFloat(unitDetails?.unitCost?.label) || 0,
            total_Value: parseFloat(salesDetails?.orignalPrice) || 0,
            measured_Value: parseFloat(salesDetails?.mainSalePrice) || 0,
            roundOff_Value: parseFloat(salesDetails?.listingPrice) || 0,
            parking_Price: parseFloat(transectionData?.parkingPrice) || 0,
            all_In_Price:
              (parseFloat(salesDetails?.profit) || 0) +
              (parseFloat(salesDetails?.sellerPaidDev) || 0) +
              amountDueDev +
              (parseFloat(salesDetails?.commPaid) || 0) +
              (parseFloat(salesDetails?.buyerTransferFee) || 0) +
              (parseFloat(salesDetails?.legalFee) || 0) +
              (parseFloat(salesDetails?.miscFee) || 0),
            premium: parseFloat(salesDetails?.profit) || 0,
            premium_Percent: parseFloat(salesDetails?.profitCalculate) || 0,
            seller_Commission: parseFloat(salesDetails?.commSeller) || 0,
            seller_Commission_Percent: parseFloat(salesDetails?.commSellerCalculate) || 0,
            buyer_Commission: parseFloat(salesDetails?.commPaid) || 0,
            buyer_Commission_Percent: parseFloat(salesDetails?.commPaidCalculate) || 0,
            seller_TransferFee: parseFloat(salesDetails?.sellerTransferFee) || 0,
            seller_TransferFee_Percent: parseFloat(salesDetails?.sellerTransferFeeCalcu) || 0,
            buyer_TransferFee: parseFloat(salesDetails?.buyerTransferFee) || 0,
            buyer_TransferFee_Percent: parseFloat(salesDetails?.buyerTransferFeeCalcu) || 0,
            admin_Fees: parseFloat(salesDetails?.legalFee) || 0,
            admin_Fees_Percent: parseFloat(salesDetails?.legalFeeCalcu) || 0,
            other_Fees: parseFloat(salesDetails?.miscFee) || 0,
            other_Fees_Percent: parseFloat(salesDetails?.miscFeeCalcu) || 0,
            other_Fees_Remarks: salesDetails?.comment || '0',
            seller_Paid: parseFloat(salesDetails?.sellerPaidDev) || 0,
            seller_Paid_Percent: parseFloat(salesDetails?.sellerPaidDevCalcu) || 0,
            developer_Due: amountDueDev,
            developer_Due_Percent: amountDueDevPercent,
            rent_Per_Annum: parseFloat(leaseDetails?.rentPerAnum) || 0,
            short_Term_Rent: parseFloat(leaseDetails?.rentByMonth) || 0,
            short_Term_Period: '0',
            rent_Per_Day: parseFloat(leaseDetails?.rentPerDay) || 0,
            security_Deposit: parseFloat(leaseDetails?.securityDeposit) || 0,
            advance_Deposit: parseFloat(unitDetails?.reservedFund) || 0,
            tenant_Commission: parseFloat(leaseDetails?.tenantCommission) || 0,
            landlord_Commission: parseFloat(leaseDetails?.landlordCommission) || 0,
            maintenance_Fee: parseFloat(leaseDetails?.maintenanceFee) || 0,
            negotiable: true,
            currency: salesDetails?.currency?.label || '0',
            cmA_Range1: parseFloat(salesDetails?.marketAnalysis) || 0,
            cmA_Range2: parseFloat(salesDetails?.to) || 0,
            installments: parseFloat(leaseDetails?.installment) || 0,
            rentPayableTo: leaseDetails?.rentPayable || '0',
            rentBankName: leaseDetails?.bankName?.label || '0',
            rentBankAcNo: leaseDetails?.accountNo || '0',
            secDepPayableTo: leaseDetails?.secDepositPayable || '0',
            comPayableTo: leaseDetails?.commissionPayable || '0',
            key_Status: unitDetails?.statusKey?.label || '0',
            publishStatus: Boolean(advertisement?.publishStatus),
            publishDate: advertisement?.publishStatus ? new Date() : new Date('1900-01-01'),
            serviceCharge: unitDetails?.serviceCharge || '0',
            ownerOccupied: Boolean(unitDetails?.occupied),
            leased: Boolean(unitDetails?.leased),
            leaseAmount: parseFloat(unitDetails?.rentAmount) || 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: unitDetails?.mandate?.label || '0',
            financeCompany: unitDetails?.financeOffered || '0',
            mortgaged: Boolean(unitDetails?.mortgaged),
            mortgageCompany: unitDetails?.company || '0',
            propertyRegistered: Boolean(unitDetails?.propertyRegistered),
            portfolio: parseFloat(unitDetails?.furnitureCost) || 0,
            portfolioManager: unitDetails?.furniturePlan?.label || '0',
            propertyType: unitDetails?.status?.label || '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: leaseDetails?.dueDate,
            listingPriceUSD: parseFloat(salesDetails?.priceinothercontry) || 0,
            monthlyIncome: (parseFloat(leaseDetails?.fixedCharges) || 0).toFixed(3),
            annualIncome: (parseFloat(leaseDetails?.variableCharges) || 0).toFixed(3),
            exp9: unitDetails?.costAccount?.label || '0',
            exp10: unitDetails?.reservedAccCode?.label || '0',
            refered_By: unitDetails?.refferedBy?.label || '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: unitDetails?.enteredBy?.label || '0',
            createdOn: unitDetails?.enteredDate,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,

          unitImages: unitImages,
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const postRes = await apiService.post('CREATE_UNIT', body);
      if (postRes?.data?.statusCode === 200 || postRes?.data?.statusCode === 201) {
        // if (attachments) {
        //   handleUpload(postRes?.data?.result?.ref_No);
        // }
        toast.success(postRes?.data?.message);
        setloader(false);
        navigate('/Customer/Property/Master/Unit/Listing');
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);

    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    // formData.append('refNo', "");
    formData.append('fileCategory', 'Images');

    // ✅ DEBUG
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post('https://lease.api.apps.rabahrain.com/api/FileUpload/files', formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    if (response?.data) {
      return response?.data?.result || [];
      // additionalDataUpload(response?.data?.result, ref_No);
    }
  };
  const additionalDataUpload = async (data, refNo) => {
    const unitFeatures = featuresList?.map((item, index) => {
      return {
        status: item?.DescType || '0',
        description: item?.Description || '0',
        value: item?.Value,
        cnt: parseFloat(item?.Cnt) || 0,
        amount: parseFloat(item?.Amount) || 0,
        isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
      };
    });
    const image = data?.map((item, index) => {
      return {
        record_Id: 0,
        image_Description: item?.originalFileName || '0',
        image_Filename: item?.fileName || '0',
        isDefault: true,
        folder: item?.filePath || '0',
        url: item?.fullUrl || '0',
        isAdded: true,
        isUpdated: false,
        isDeleted: false,
      };
    });
    const body = {
      refNo: refNo || '0',
      unitFeatures: unitFeatures,
      unitImages: image,
      unitPayables: [
        {
          description: '0',
          value: true,
          landlord: true,
          tenant: true,
        },
      ],
      unitYearlyRents: [
        {
          year: 0,
          rentPerSqftRest: 0,
          rentPerSqftKitchen: 0,
          rentPerSqftTerrace: 0,
          totalRent: 0,
          scPerSqftRest: 0,
          scPerSqftKitchen: 0,
          scPerSqftTerrace: 0,
          totalServiceCharge: 0,
          chilledWaterPerSqftRest: 0,
          chilledWaterPerSqftKitchen: 0,
          chilledWaterPerSqftTerrace: 0,
          totalChilledWaterCharge: 0,
        },
      ],
      unitFixedCharges: [
        {
          description: '0',
          amount: 0,
        },
      ],
    };
    const postRes = await apiService.post('POST_UNIT_ADDITIONAL', body);
  };
  return (
    <div className="p-3">
      <div className="border-box2 p-2 d-flex justify-content-between" style={{ borderRadius: '8px' }}>
        <div className="">
          <h6>Unit Master</h6>
        </div>
        <div className="d-flex gap-3">
          {loading === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnSecondary flex-end gap-2" onClick={handleBackClick}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4">
          {tabList.map((tab, index) => (
            <div
              key={tab.key}
              className={`dashitems sidebar-text center ${activeTab === index ? 'sideActive' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      {tabList[activeTab]?.key === 'unitMaster' && (
        <MasterDetails
          tableLoading={tableLoading}
          countriesList={countriesList}
          salersList={salersList}
          setCityList={setCityList}
          setTransectionData={setTransectionData}
          propertyList={propertyList}
          cityList={cityList}
          setFeaturesList={setFeaturesList}
          transectionData={transectionData}
          landlordList={landlordList}
          communityList={communityList}
          unitTypeList={unitTypeList}
          unitViewList={unitViewList}
          floorList={floorList}
          unitCategoryList={unitCategoryList}
          setcommunityList={setcommunityList}
          setunitCategoryList={setunitCategoryList}
          bedRoomList={bedRoomList}
        />
      )}
      {tabList[activeTab]?.key === 'unitDetails' && (
        <UnitDetails
          tableLoading={tableLoading}
          manDateList={manDateList}
          reserveAccList={reserveAccList}
          agent={agent}
          setTransectionData={setUnitDetails}
          keyStatusList={keyStatusList}
          unitCostList={unitCostList}
          paymentPlan={paymentPlan}
          furnishing={furnishing}
          transectionData={unitDetails}
          projectStatus={projectStatus}
          costAccount={costAccount}
          refferedBy={refferedBy}
          enteredBy={enteredBy}
          furniturePlan={furniturePlan}
        />
      )}
      {tabList[activeTab]?.key === 'unitFeatures' && <UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />}
      {tabList[activeTab]?.key === 'salesDetails' && (
        <SalesDetails tableLoading={tableLoading} setTransectionData={setSalesDetails} transectionData={salesDetails} countriesList={countriesList} totalArea={transectionData?.totalArea} />
      )}
      {tabList[activeTab]?.key === 'buyerSummary' && <BuyerSummery tableLoading={tableLoading} salesDetails={salesDetails} />}
      {tabList[activeTab]?.key === 'leaseDetails' && (
        <LeaseDetails
          tableLoading={tableLoading}
          setTransectionData={setLeaseDetails}
          transectionData={leaseDetails}
          bankList={bankList}
          unitClass={transectionData?.unitClass}
        />
      )}
      {tabList[activeTab]?.key === 'payable' && <Payable tableLoading={tableLoading} />}
      {tabList[activeTab]?.key === 'advertisement' && (
        <Advertisement tableLoading={tableLoading} setTransectionData={setAdvertisement} transectionData={advertisement} />
      )}
      {tabList[activeTab]?.key === 'images' && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />}
    </div>
  );
};
export default CreateUnitMaster;
